import { render, staticRenderFns } from "./HeaderPatientSearch.vue?vue&type=template&id=53f07a70&scoped=true"
import script from "./HeaderPatientSearch.vue?vue&type=script&lang=js"
export * from "./HeaderPatientSearch.vue?vue&type=script&lang=js"
import style0 from "./HeaderPatientSearch.vue?vue&type=style&index=0&id=53f07a70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f07a70",
  null
  
)

export default component.exports